/* eslint-disable react/no-danger */
/* eslint-disable react/require-default-props */
/* eslint-disable no-cond-assign */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
import SanitizeWord from 'services/sanitize_word';
import RemoveAcronym from 'services/remove_acronym';
import _ from 'underscore';
import { PreText, Text } from './styles';

interface HighlightedTextProps {
  className: string;
  termsList: Array<string>;
  text: string;
  pre?: boolean;
  removeAcronym?: boolean;
}

function HighlightedText(props: HighlightedTextProps) {
  const { className, termsList, text, pre = false, removeAcronym = false } = props;

  const OPEN_MARK = '!@#';
  const CLOSE_MARK = '$%&';
  const WORDS_THRESHOLD = 1000;
  let rawMessage = '';

  const [highlightedText, setHighlightedText] = useState<string>('');
  const [highlighted, setHighlighted] = useState<boolean>(false);
  const [mounted, setMounted] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const highlight = () => {
    if (!text) return;

    if (termsList?.length === 0) {
      setHighlightedText(text);
      setHighlighted(true);
      return;
    }

    if (removeAcronym) rawMessage = RemoveAcronym(text);
    if (!removeAcronym) rawMessage = text;
    let highlightedMessage = '';

    const rawMessageSplitted = rawMessage
      .split(/(\s+)/)
      .filter((word) => word !== ' ')
      .slice(currentPage * WORDS_THRESHOLD, currentPage * WORDS_THRESHOLD + WORDS_THRESHOLD);

    const singleKeywords = termsList?.filter((term) => term.split(' ')?.length === 1) || [];
    const compoundKeywords = termsList?.filter((term) => term.split(' ')?.length > 1) || [];

    for (let wordIndex = 0; wordIndex < rawMessageSplitted?.length; wordIndex++) {
      let matches = 0;
      const sanitizedWord = SanitizeWord(rawMessageSplitted[wordIndex]);

      const sanitizedKeywords = singleKeywords.map((keyword) => SanitizeWord(keyword, true));

      sanitizedKeywords.forEach((sanitizedKeyword) => {
        const regex = new RegExp(sanitizedKeyword, 'gi');
        if (sanitizedWord.match(regex)) {
          matches++;
        }
      });

      if (matches === 0) highlightedMessage += `${rawMessageSplitted[wordIndex]} `;
      if (matches > 0)
        highlightedMessage += `${OPEN_MARK}${rawMessageSplitted[wordIndex]}${CLOSE_MARK} `;
    }

    compoundKeywords.forEach((compoundKeyword) => {
      const regex = new RegExp(SanitizeWord(compoundKeyword, true), 'i');
      const occurrences = [];

      if (SanitizeWord(highlightedMessage).match(regex)) {
        const regex = new RegExp(SanitizeWord(compoundKeyword, true), 'gi');
        let match;
        while ((match = regex.exec(SanitizeWord(highlightedMessage)))) {
          const occurrence = {
            index: match.index,
            term: match[0],
          };
          occurrences.push(occurrence);
        }

        const originalTerms = occurrences.map((occurrence) =>
          highlightedMessage.slice(occurrence.index, occurrence.index + occurrence.term.length),
        );

        _.uniq(originalTerms).forEach((originalTerm) => {
          highlightedMessage = highlightedMessage.replaceAll(
            originalTerm,
            `${OPEN_MARK}${originalTerm}${CLOSE_MARK}`,
          );
        });
      }
    });

    highlightedMessage = highlightedMessage.replaceAll(
      OPEN_MARK,
      '<mark class="message-keyword" data-toggle="tooltip" data-placement="top" title="Palavra chave">',
    );
    highlightedMessage = highlightedMessage.replaceAll(CLOSE_MARK, '</mark>');

    setHighlightedText(highlightedText + highlightedMessage);
    setHighlighted(true);
  };

  useEffect(() => {
    if (!mounted) return;

    if (!text) return;

    highlight();
  }, [mounted, currentPage]);

  useEffect(() => {
    setMounted(true);
  }, []);

  const highlightedElement = () => {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: highlightedText }} />
        {termsList?.length > 0 &&
          currentPage + 1 <
            Math.ceil(
              text.split(/(\s+)/).filter((word) => word !== ' ').length / WORDS_THRESHOLD,
            ) && (
            <button
              type="button"
              className="btn btn-link m-0 py-0 px-1 border-0"
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Mostrar mais
            </button>
          )}
      </>
    );
  };

  return (
    <>
      {pre && highlighted && <PreText className={className}>{highlightedElement()}</PreText>}
      {!pre && highlighted && <Text className={className}>{highlightedElement()}</Text>}
      {!highlighted && <div className={className}>{text}</div>}
    </>
  );
}
export default HighlightedText;
